// extracted by mini-css-extract-plugin
export default {"baseStyles":"_13i1u"};